const { localStorageKeys } = require('./../../../../bs-embeds/src/config/localStorage.js');
import './../../../../bs-embeds/src/helpers/currency.js';


export default {
    init() {
    // JavaScript to be fired on all pages
        var $body = $('body');

        $('[data-toggle-mob-menu]').click(function(){
            $body.toggleClass($(this).data('toggle-mob-menu') + '-active');
        });

        $body.on('click', '.tev-search-filters-menu-toggle', function() {
            $body.toggleClass('search-filters-menu-active');
        });

        $('#signup-form').submit(function(e) {
            var api = 'https://booking.exclusiveprivatevillas.com/api/';
            e.preventDefault();

            var form = $(this);

            $.ajax({
                type: 'POST',
                url: api + 'newsletter',
                data: form.serialize(),
                success: function (data) {
                    console.log(data);
                    form.replaceWith(
                        '<div class="alert alert-success">Thank you for subscribing to our mailing list. You will now be the first to receive expert advice and suggestions for your next Villa holiday.</div>'
                    );
                },
                error: function (data) {
                    console.log(data);
                },
            });
        });

        var breakpoints = {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
        };

        function move($el) {
            var size = 'desktop';
            if ($(window).width() < breakpoints[$el.data('reattach-breakpoint')]) {
                size = 'mobile';
            }
            $el.appendTo($('#' + $el.attr('id') + '-' + size));
        }

        $(function() {
            $('[data-reattach-breakpoint]').each(function() {
                var $el = $(this);
                move($el);
                $(window).resize(function() {
                    move($el);
                });
            });
        });

        // Open property page links in new tab if desktop
        $('body').on('click', '.tev-property-card-carousel .slick-slide', function(){
            window.open($(this).closest('.tev-property-card-carousel').data('property-href'), $(window).width() >= breakpoints['xl'] ? '_blank' : '_self');
        });


        var checkExist = setInterval(function() {
            if ($('#shortlistbutton').length) {
                clearInterval(checkExist);
                let shortlist = (localStorage[localStorageKeys.shortlist] !== undefined && localStorage[localStorageKeys.shortlist]) ? $.parseJSON(localStorage[localStorageKeys.shortlist]) : [];
                if (shortlist.length > 0) {
                    document.getElementsByClassName('btn--shortlist')[0].classList.add('btn--shortlist-not-empty');
                } else {
                    document.getElementsByClassName('btn--shortlist')[0].classList.remove('btn--shortlist-not-empty');
                }
            }
        }, 100); // check every 100ms

    },
    finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js